import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, setCsrfToken } from "@/lib/api";
import { applyBrandColor } from "@/lib/branding";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState({ status: "loading", me: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setCsrfToken(data.csrf_token);
      localStorage.setItem("onsuite:uid", data.id || data.user?.id || "");
      const br = await api.get("/branding").then((r) => r.data).catch(() => null);
      applyBrandColor(br?.color);
      setState({ status: "authed", me: { ...data, branding: br } });
    } catch {
      setCsrfToken(null);
      setState({ status: "anon", me: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setCsrfToken(null);
      setState({ status: "anon", me: null });
      window.location.assign("/login");
    }
  }, []);

  const value = useMemo(() => {
    const perms = new Set(state.me?.permissions || []);
    return { ...state, refresh, logout, can: (p) => perms.has(p) };
  }, [state, refresh, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
